import React from "react";

export default function Rewards() {
  return <div>Rewards</div>;
}
